import Cookies from 'js-cookie';

export function initFitmentApplication() {
    var $facetsString = $('#vehicleFacets');

    if ($facetsString.length) {
        Cookies.set('pace-fitment-application', $facetsString.val(), {
            expires: 365,
            path: "/;SameSite=None",
            secure: true
        });
    }

    if (typeof Cookies.get('pace-fitment-application') !== typeof undefined) {
        var applicationOutput = '';
        var fitmentOutput = '';
        var vehicleYear = $('#vehicleYear').val();
        var vehicleMakeName = $('#vehicleMakeName').val();
        var vehicleModelName = $('#vehicleModelName').val();
        var vehicleEngineMfrName = $('#vehicleEngineMfrName').val();
        var vehicleEngineFamilyName = $('#vehicleEngineFamilyName').val();
        var vehicleEngineSizeName = $('#vehicleEngineSizeName').val();
        var ymmIsSet =
            typeof vehicleYear !== typeof undefined &&
            typeof vehicleMakeName !== typeof undefined &&
            typeof vehicleModelName !== typeof undefined;
        var engineIsSet =
            typeof vehicleEngineMfrName !== typeof undefined &&
            (typeof vehicleEngineFamilyName !== typeof undefined ||
                typeof vehicleEngineSizeName !== typeof undefined);
        var fitmentIsSet = ymmIsSet || engineIsSet;

        if (fitmentIsSet) {
            fitmentOutput += '<div class="application-info">';
            fitmentOutput +=
                '<p><strong>' +
                (ymmIsSet ? 'Application' : 'Engine') +
                '</strong></p>';
            fitmentOutput += '<p>';

            if (ymmIsSet) {
                fitmentOutput +=
                    vehicleYear +
                    ' / ' +
                    vehicleMakeName +
                    ' / ' +
                    vehicleModelName;
            } else if (engineIsSet) {
                fitmentOutput += vehicleEngineMfrName;

                if (typeof vehicleEngineFamilyName !== typeof undefined) {
                    fitmentOutput += ' / ' + vehicleEngineFamilyName;
                }

                if (typeof vehicleEngineSizeName !== typeof undefined) {
                    fitmentOutput += ' / ' + vehicleEngineSizeName;
                }
            }

            fitmentOutput +=
                ' <a href="/catalog/reset-vehicle/" class="reset-ymm" title="Reset"><i class="fa fa-times"></i></a>';
            fitmentOutput += '</p>';

            var vehicleFacets = Cookies.get('pace-fitment-application').split(
                ';'
            );
            var newCookie = '';

            for (var i = 0; i < vehicleFacets.length - 1; i++) {
                var facetTokens = vehicleFacets[i].split('=');
                var facetNameTokens = facetTokens[0].split(':');
                var facetValueTokens =
                    facetTokens[facetTokens.length - 1].split(':');
                var facetName = facetNameTokens[0];
                var facetLabel = facetNameTokens[facetNameTokens.length - 1];
                var facetOption = facetValueTokens[0];
                var facetText = facetValueTokens[facetValueTokens.length - 1];

                if ($('#vehicle' + facetName).length) {
                    var facetOutput =
                        '<p>' +
                        facetLabel +
                        ': ' +
                        facetText +
                        ' <a href="#" title="Remove Vehicle Facet" data-remove-facet="' +
                        facetName +
                        '"><i class="fa fa-times"></i></a></p>';

                    newCookie +=
                        facetName +
                        ':' +
                        facetLabel +
                        '=' +
                        facetOption +
                        ':' +
                        facetText +
                        ';';

                    if (
                        facetLabel !== 'Year' &&
                        facetLabel !== 'Make' &&
                        facetLabel !== 'Model'
                    ) {
                        applicationOutput += facetOutput;
                        fitmentOutput += facetOutput;
                    }
                }
            }

            Cookies.set('pace-fitment-application', newCookie, {
                expires: 365,
                path: "/;SameSite=None", secure: true
            });

            fitmentOutput += '</div>';

            $('#fitment-application-facets').html(applicationOutput);

            $('.fitment-label').each(function (i, item) {
                var fitmentInfo = $(this)
                    .closest('.product-group')
                    .find('.fitment-info');

                if (!$(this).hasClass('load-fitment')) {
                    if (fitmentInfo.find('.application-info').length) {
                        fitmentInfo
                            .find('.application-info')
                            .replaceWith(fitmentOutput);
                    } else {
                        fitmentInfo.prepend(fitmentOutput);
                    }
                }
            });
        }
    }

    $(document).on('click', '[data-remove-facet]', function (e) {
        e.preventDefault();
        var self = $(this);
        var facetToRemove = self.attr('data-remove-facet');

        $.ajax({
            url: 'catalog/ajaxRemoveFacet/',
            type: 'post',
            dataType: 'json',
            data: { facet: facetToRemove },
            success: function (data) {
                if (data == true) {
                    if (
                        typeof Cookies.get('pace-fitment-application') !==
                        typeof undefined
                    ) {
                        var newCookie = '';
                        var vehicleFacets = Cookies.get(
                            'pace-fitment-application'
                        ).split(';');

                        for (var i = 0; i < vehicleFacets.length - 1; i++) {
                            var facetTokens = vehicleFacets[i].split('=');
                            var facetNameTokens = facetTokens[0].split(':');
                            var facetValueTokens =
                                facetTokens[facetTokens.length - 1].split(':');
                            var facetName = facetNameTokens[0];
                            var facetLabel =
                                facetNameTokens[facetNameTokens.length - 1];
                            var facetOption = facetValueTokens[0];
                            var facetText =
                                facetValueTokens[facetValueTokens.length - 1];

                            if (facetName !== facetToRemove) {
                                newCookie +=
                                    facetName +
                                    ':' +
                                    facetLabel +
                                    '=' +
                                    facetOption +
                                    ':' +
                                    facetText +
                                    ';';
                            }
                        }

                        Cookies.set('pace-fitment-application', newCookie, {
                            expires: 365,
                            path: "/;SameSite=None", secure: true
                        });
                    }

                    window.location = window.location;
                }
            },
        });
    });
}
